import { t } from 'i18next';
import { useModal } from 'components/modal/ModalStack';
import { classNames } from 'libs/react';
import { useEffect } from 'libs/react';
import { useState } from 'libs/react';
import { remove } from 'libs/util/array';
import { MediaPickerItem } from './MediaPickerItem';
import { Button } from 'components/Button';
import { MediaLibrary } from 'components/media/MediaLibrary';
import { React } from 'libs/react';
import './MediaPicker.scss';
/**
 * @component MediaPicker
 * @since 1.0.0
 */
export function MediaPicker(props) {
    const { size, style, title, types, editable, multiple, useLink, fromPublic } = Object.assign({ size: 'medium', style: 'normal', types: 'image/*, application/pdf', multiple: false }, props);
    const modal = useModal();
    const [medias, setMedias] = useState(props.medias || []);
    /**
     * @function onBrowse
     * @since 1.0.0
     * @hidden
     */
    function onBrowse() {
        modal.present({
            title: t('Select Media'),
            picto: 'images',
            className: 'media-picker-modal',
            modal: (React.createElement(MediaLibrary, { types: types, onSelect: onSelect, multiple: multiple, fromPublic: fromPublic }))
        });
    }
    /**
     * @function onItemClick
     * @since 1.0.0
     * @hidden
     */
    function onItemClick(media) {
        if (props.onItemClick) {
            props.onItemClick(media);
        }
    }
    /**
     * @function onSelect
     * @since 1.0.0
     * @hidden
     */
    function onSelect(medias) {
        setMedias(medias);
        if (props.onPick) {
            props.onPick(multiple ? medias : medias[0]);
        }
        modal.dismiss();
    }
    /**
     * @function onRemove
     * @since 1.0.0
     * @hidden
     */
    function onRemove(media) {
        const mediasCopy = [...medias];
        remove(mediasCopy, media);
        setMedias(mediasCopy);
        if (props.onPick) {
            props.onPick(mediasCopy);
        }
    }
    /**
     * @function onReorder
     * @since 1.0.0
     * @hidden
     */
    function onReorder(from, to) {
        if (from === to) {
            return;
        }
        const mediasCopy = [...medias];
        const [moved] = mediasCopy.splice(from, 1);
        mediasCopy.splice(to, 0, moved);
        setMedias(mediasCopy);
        if (props.onPick) {
            props.onPick(mediasCopy);
        }
    }
    useEffect(() => {
        setMedias(props.medias || []);
    }, [props.medias]);
    const className = classNames('media-picker', 'media-picker--' + size, 'media-picker--' + style, { 'media-picker--has-media': medias.length > 0 }, { 'media-picker--multiple': multiple }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "media-picker-body" }, medias.map((media, index) => (React.createElement(MediaPickerItem, { key: media.url, index: index, media: media, onItemClick: onItemClick, onRemove: onRemove, onReorder: multiple ? onReorder : undefined, editable: editable, types: types })))),
        !useLink ? (React.createElement("div", { className: "media-picker-foot" },
            React.createElement(Button, { className: "media-picker-select-button", style: "primary", label: t('Select'), onPress: onBrowse }))) : (medias.length === 0 && (React.createElement("div", { className: "media-picker-image-text", onClick: onBrowse }, title !== null && title !== void 0 ? title : t('Select Image'))))));
}
